module.exports = __webpack_public_path__ + "static/media/sumo-logo.f28dea4c.png";